import React, { useState, useEffect } from 'react';

export const PolymarketCard = ({ theme, isDark }) => {
  const [events, setEvents] = useState([]);
  const [stats, setStats] = useState({ totalLiquidity: 0, totalVolume: 0 });
  const [loading, setLoading] = useState(true);

  const PROXY_URL = '/api/poly/api/markets';

  useEffect(() => {
    fetch(PROXY_URL)
      .then(res => res.json())
      .then(data => {
        // Filter for events with active markets
        const activeEvents = data.filter(event => 
          event.markets.some(m => m.outcomePrices !== '["0", "1"]' && m.outcomePrices !== '["1", "0"]')
        );
        
        const topEvents = activeEvents.slice(0, 12);
        
        // --- CALCULATION LOGIC ---
        let totalLiq = 0;
        let totalVol = 0;

        topEvents.forEach(event => {
          event.markets.forEach(m => {
            totalLiq += parseFloat(m.liquidity || 0);
            // Gamma API often provides 'volume' as total trading activity
            totalVol += parseFloat(m.volume || 0); 
          });
        });

        setStats({ totalLiquidity: totalLiq, totalVolume: totalVol });
        setEvents(topEvents);
        setLoading(false);
      })
      .catch(err => console.error("Gamma API Error:", err));
  }, []);

  if (loading) return <div style={{ color: theme.textSecondary, padding: '1rem' }}>Sincronizando previsões...</div>;

  return (
    <div style={{ 
      background: theme.cardBg, 
      border: `1px solid ${theme.border}`,
      borderRadius: '12px',
      padding: '2rem',
      backdropFilter: 'blur(10px)',
      marginBottom: '2rem'
    }}>
      {/* --- NEW STATISTICAL HEADER --- */}
      <div style={{ 
        background: 'rgba(212, 175, 55, 0.05)', 
        border: `1px solid ${theme.border}`,
        borderRadius: '8px',
        padding: '1.5rem',
        marginBottom: '2rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '0.5rem'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
          <div>
            <h2 style={{ fontSize: '1.8rem', fontWeight: '800', color: theme.textPrimary, margin: 0 }}>
              Deixe a criptomoeda rendendo...
            </h2>
            <p style={{ color: theme.textSecondary, margin: '5px 0 0 0', fontSize: '0.9rem' }}>
              Amostragem estatística baseada em capital alocado (USDC) em mercados de predição.
            </p>
          </div>
          <div style={{ textAlign: 'right' }}>
            <span style={{ fontSize: '0.7rem', color: '#D4AF37', fontWeight: 'bold', textTransform: 'uppercase' }}>
              Liquidez Total Monitorada
            </span>
            <div style={{ fontSize: '1.5rem', fontWeight: '800', color: '#D4AF37' }}>
              ${stats.totalLiquidity.toLocaleString(undefined, { maximumFractionDigits: 0 })}
            </div>
          </div>
        </div>
      </div>

      {/* --- GRID OF CARDS --- */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '1.5rem' }}>
        {events.map((event) => {
          const activeMarkets = event.markets.filter(m => m.outcomePrices !== '["0", "1"]');
          const market = activeMarkets[0] || event.markets[0];
          
          const prices = JSON.parse(market.outcomePrices || "[]");
          const outcomes = JSON.parse(market.outcomes || "[]");
          const yesPrice = parseFloat(prices[0] || 0) * 100;

          return (
            <div key={event.id} style={{ 
              background: theme.itemBg, 
              padding: '1.2rem', 
              borderRadius: '10px',
              border: `1px solid ${theme.border}`,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between'
            }}>
              <div>
                <p style={{ color: theme.textSecondary, fontSize: '0.65rem', textTransform: 'uppercase', marginBottom: '8px' }}>
                  {market.question}
                </p>
                <h4 style={{ color: theme.textPrimary, fontSize: '1rem', margin: '0 0 15px 0', lineHeight: '1.4', fontWeight: '700' }}>
                  {event.title}
                </h4>
                
                <div style={{ marginBottom: '15px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px', fontSize: '0.85rem' }}>
                    <span style={{ fontWeight: 'bold', color: '#D4AF37' }}>{outcomes[0]}: {yesPrice.toFixed(1)}%</span>
                    <span style={{ color: theme.textSecondary }}>{outcomes[1]}</span>
                  </div>
                  <div style={{ width: '100%', height: '6px', background: 'rgba(255,255,255,0.05)', borderRadius: '10px', overflow: 'hidden' }}>
                    <div style={{ 
                      width: `${yesPrice}%`, 
                      height: '100%', 
                      background: `linear-gradient(90deg, #D4AF37, ${isDark ? '#5A0F27' : '#DC143C'})`,
                      transition: 'width 1s ease-out'
                    }} />
                  </div>
                </div>
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: `1px solid ${theme.border}`, paddingTop: '10px' }}>
                <span style={{ fontSize: '0.7rem', color: theme.textSecondary }}>
                  Liquidez: <b style={{ color: theme.textPrimary }}>${market.liquidity ? parseFloat(market.liquidity).toLocaleString() : '0'}</b>
                </span>
                <span style={{ fontSize: '0.7rem', color: '#22c55e', fontWeight: 'bold' }}>
                  LIVE 📡
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};